import { createSlice } from '@reduxjs/toolkit';
import { fetchLabels, createLabel, updateLabel, deleteLabel } from './action';

const labelSlice = createSlice({
  name: 'label',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabels.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLabels.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload || [];
      })
      .addCase(fetchLabels.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to load labels';
      })
      .addCase(createLabel.fulfilled, (state, action) => {
        const item = action.payload;
        if (item) state.data.push(item);
      })
      .addCase(updateLabel.fulfilled, (state, action) => {
        const updated = action.payload;
        if (!updated?._id) return;
        const idx = state.data.findIndex((t) => t._id === updated._id);
        if (idx !== -1) state.data[idx] = updated;
      })
      .addCase(deleteLabel.fulfilled, (state, action) => {
        const id = action.payload;
        state.data = state.data.filter((t) => t._id !== id);
      });
  },
});

export default labelSlice.reducer;

